
import template from './employee_search.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeSearchViewModel
{
	constructor(page)
	{
		this.records = ko.observableArray();
		this.page = page;
		this.employee = ko.observable();
		this.selected_employee = ko.observable();
		this.employee_fields = ko.observableArray();
		this.leave_date_overlaps = ko.observable('false');
		this.is_viewing_own_profile = ko.observable('false');
	}
}

class EmployeeSearchPage
{
	constructor(bindings, element)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeSearchViewModel(this);
	}

	// Event (Post/After): Load once
	async init()
	{
		document.title = tr('Search Employee');
		let title = tr('Search Employee');
		window.current_page_title(title);
	}
}

export default {
	route: `[/]employee/search`,
	page_class: EmployeeSearchPage,
	template: template,
	template_filename: 'translation/employee_search'
};
